import { useState } from "react";
import axios from "axios";
import { KeyRound, Mail } from "lucide-react";
import { API } from "@/lib/api";

// Passo de verificação: pede o código por email e valida-o antes de mostrar o documento.
export default function OtpGate({ token, info, onVerified }) {
  const [sent, setSent] = useState(null);
  const [code, setCode] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const base = `${API}/sign/public/${token}/otp`;
  const call = async (fn) => {
    setBusy(true); setMsg("");
    try { await fn(); } catch (e) { setMsg(e.response?.data?.detail || "Não foi possível concluir. Tente novamente."); }
    setBusy(false);
  };
  const request = () => call(async () => setSent((await axios.post(`${base}/request`, {}, { timeout: 20000 })).data));
  const verify = () => call(async () => onVerified((await axios.post(`${base}/verify`, { code }, { timeout: 20000 })).data.session));

  if (!info.email_available || !info.email_service) {
    return (
      <div className="rounded-xl border border-amber-500/30 bg-amber-500/10 text-amber-100 p-4 text-sm" data-testid="otp-unavailable">
        {!info.email_available ? "Não existe email registado para este pedido." : "A verificação por email está indisponível de momento."} Contacte o profissional para assinar presencialmente.
      </div>
    );
  }
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/50 p-6 space-y-4" data-testid="otp-gate">
      <div className="flex items-center gap-2 text-slate-50 font-display"><KeyRound className="w-4 h-4 text-sky-400" /> Verificação de identidade</div>
      <p className="text-sm text-slate-400">
        Para abrir o documento, enviamos um código de 6 dígitos para <span className="text-slate-200" data-testid="otp-email-hint">{info.email_hint}</span>. O código é válido durante {info.ttl_min} minutos.
      </p>
      {sent && (
        <div className="space-y-2">
          <input data-testid="otp-code-input" inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="000000"
            className="w-full rounded-xl bg-slate-950 border border-slate-700 text-slate-100 px-3 py-3 text-center text-2xl tracking-[0.5em]" />
          <button data-testid="otp-verify-btn" disabled={busy || code.length !== 6} onClick={verify}
            className="w-full rounded-full bg-sky-500 hover:bg-sky-400 disabled:opacity-50 text-slate-950 font-medium px-4 py-2.5 text-sm transition-colors">Validar código</button>
        </div>
      )}
      <button data-testid="otp-request-btn" disabled={busy} onClick={request}
        className={`inline-flex items-center gap-2 text-sm ${sent ? "text-sky-300 underline" : "w-full justify-center rounded-full bg-sky-500 hover:bg-sky-400 text-slate-950 font-medium px-4 py-2.5"} disabled:opacity-50 transition-colors`}>
        <Mail className="w-4 h-4" /> {sent ? "Enviar novo código" : "Enviar código"}
      </button>
      {msg && <div className="text-sm text-rose-300" data-testid="otp-message">{msg}</div>}
    </div>
  );
}
